import type { ReactNode } from 'react';

import { cx, toneClass, type Tone } from './cx';

export function Badge({
  tone = 'neutral',
  children,
  className,
  size = 'md',
}: {
  tone?: Tone;
  children: ReactNode;
  className?: string;
  size?: 'sm' | 'md';
}) {
  return (
    <span
      className={cx(
        'inline-flex items-center gap-[5px] rounded-sm font-semibold whitespace-nowrap',
        size === 'md' ? 'px-[9px] py-1 text-xs' : 'px-2 py-0.5 text-[11px]',
        toneClass[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}

/** Mala oznaka „Uskoro“ / „U razvoju“. */
export function SoonTag({ children }: { children: ReactNode }) {
  return (
    <span className="rounded-sm bg-chip px-[7px] py-0.5 text-[10px] font-semibold tracking-[.06em] text-accent uppercase">
      {children}
    </span>
  );
}

/** Brojač u sidebaru / tabovima. */
export function CountPill({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <span
      className={cx(
        'min-w-[22px] rounded-full border border-line bg-bg2 px-[7px] py-0.5 text-center text-[11px] font-semibold text-muted',
        className,
      )}
    >
      {children}
    </span>
  );
}
